import { createSelector } from 'reselect';
import { RootState } from 'store/types';

export const snacksSelector = (state: RootState) => state.snacks;

export const snackClosingSelector = createSelector(snacksSelector, snacks => snacks.closing);

export const snacksDataSelector = createSelector(snacksSelector, snacks => snacks.data);
